import { observable, action, computed, autorun } from "mobx";

import { BaseStore, Delay } from "./BaseStore";

import { ReportsEndpoints } from "../endpoints/ReportsEndpoints";

/**
 *
 * @deprecated
 * TODO: Remove this, it's not managing any state so we can go straight to the endpoints
 */
export class ReportStore extends BaseStore {
    constructor(private reportsEndpoints: ReportsEndpoints) {
        super();
    }

    @action async getInspectionAddress(saleId: number): Promise<string> {
        this.setLoading();
        try {
            const inspectionAddressReport = await this.reportsEndpoints.getInspectionAddress(saleId);
            return inspectionAddressReport;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getComplianceStatus(saleId: number): Promise<string> {
        this.setLoading();
        try {
            const complianceStatus = await this.reportsEndpoints.getComplianceStatus(saleId);
            return complianceStatus;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getHipNumAndConsignors(saleId: number, consignorId: number): Promise<string> {
        this.setLoading();
        try {
            const hipNumAndConsignors = await this.reportsEndpoints.getHipNumAndConsignors(saleId, consignorId);
            return hipNumAndConsignors;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getSalePreview(saleId: number): Promise<string> {
        this.setLoading();
        try {
            const salePreview = await this.reportsEndpoints.getSalePreview(saleId);
            return salePreview;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getCatalogInformation(saleId: number): Promise<string> {
        this.setLoading();
        try {
            const catalogInformation = await this.reportsEndpoints.getCatalogInformation(saleId);
            return catalogInformation;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getIndexes(saleId: number, indexName: string): Promise<string> {
        this.setLoading();
        try {
            const indexes = await this.reportsEndpoints.getIndexes(saleId, indexName);
            return indexes;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getFullCircleEnrollment(saleId: number): Promise<string> {
        this.setLoading();
        try {
            const fullCircleEnrollment = await this.reportsEndpoints.getFullCircleEnrollment(saleId);
            return fullCircleEnrollment;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getHFSMasterlist(saleId: number): Promise<string> {
        this.setLoading();
        try {
            const hfsMasterlist = await this.reportsEndpoints.getHFSMasterlist(saleId);
            return hfsMasterlist;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getBuyerInsuranceReport(saleId: number, insuranceCompanyId: number): Promise<string> {
        this.setLoading();
        try {
            const buyerInsuranceReport = await this.reportsEndpoints.getBuyerInsuranceReport(saleId, insuranceCompanyId);
            return buyerInsuranceReport;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getHorsesWithdrawnWithoutVetCertificateReport(saleId: number, consignorId: number): Promise<string> {
        this.setLoading();
        try {
            const report = await this.reportsEndpoints.getHorsesWithdrawnWithoutVetCertificateReport(saleId, consignorId);
            return report;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getStakeEngagementListReport(saleId: number, horseForSaleId: number): Promise<string> {
        this.setLoading();
        try {
            const stakeEngagementList = await this.reportsEndpoints.getStakeEngagementListReport(saleId, horseForSaleId);
            return stakeEngagementList;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getFinalSaleReport(saleId: number): Promise<string> {
        this.setLoading();
        try {
            const finalSaleReport = await this.reportsEndpoints.getFinalSale(saleId);
            return finalSaleReport;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getFinancialSummary(fromDate: number, toDate: number): Promise<string> {
        this.setLoading();
        try {
            const financialSummary = await this.reportsEndpoints.getFinancialSummary(fromDate, toDate);
            return financialSummary;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getCustomerEmail(saleId: number, role: string): Promise<string> {
        this.setLoading();
        try {
            const customerEmail = await this.reportsEndpoints.getCustomerEmail(saleId, role);
            return customerEmail;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getHorsesByYear(year: string): Promise<string> {
        this.setLoading();
        try {
            const horsesByYear = await this.reportsEndpoints.getHorsesByYear(year);
            return horsesByYear;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action async getFinalSaleReportForSelectedConsignor(saleId: number, consignorId: number): Promise<string> {
        this.setLoading();
        try {
            const finalSaleReportForSelectedConsignor = await this.reportsEndpoints.getFinalSaleReportForSelectedConsignor(saleId, consignorId);
            return finalSaleReportForSelectedConsignor;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/ReportStore.ts